import { Room } from "../Model/Room";
import { v4 as createUuid } from 'uuid';
import { RoomRewards } from "../Model/RoomRewards";
import { RoomReward } from "../Model/RoomReward";
export class RoomsFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createRoom(accountId, roomId = createUuid(), enabled = true, integratedDisplay = false, showRoomQrInMonitor = true, pictureId = null, name = '', secondsBetweenMessages = 10, state = 'idle', gallery = [], roomRewards = this.createEmptyRoomRewards()) {
        return new Room(this.eventsChannelFactory, roomId, accountId, enabled, integratedDisplay, showRoomQrInMonitor, pictureId, name, secondsBetweenMessages, state, gallery, roomRewards);
    }
    createEmptyRoomRewards() {
        const bingo = new RoomReward('');
        const figure = new RoomReward('');
        return new RoomRewards(bingo, figure);
    }
}
